import { render } from "./distributed.vue?vue&type=template&id=751475ed&scoped=true"
import script from "./distributed.vue?vue&type=script&lang=js"
export * from "./distributed.vue?vue&type=script&lang=js"

import "./distributed.vue?vue&type=style&index=0&id=751475ed&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751475ed"]])

export default __exports__